// extracted by mini-css-extract-plugin
export default {"node":"NodeTypes_node__3LhZj","content":"NodeTypes_content__m8LkD","handle":"NodeTypes_handle__8bu-a","placeholder":"NodeTypes_placeholder__s7RHJ"};